import M from 'materialize-css'
import videojs from 'video.js'
import 'videojs-contrib-quality-levels'
import 'videojs-hls-quality-selector'

const Nanotube = {
  init: function() {
    const vidDescription = document.querySelector('textarea#video_description')
    if (vidDescription != null) {
      M.CharacterCounter.init(vidDescription)
    }

    if(this.playerExists()) {
      this.initVideoJs()
    }
  },

  dispose: function() {
    if (this.playerExists()) {
      videojs('player').dispose()
    }
  },

  initVideoJs: function() {
    let player = videojs('player')
    player.hlsQualitySelector({
      displayCurrentQuality: true,
    })

    player.play()
  },

  playerExists: function() {
    return document.querySelector("video-js#player") != null
  }
}

export default Nanotube
